import React from 'react';

export default function EmployeeHeader({heading, subheading}) {
    return (
        <div className="px-xl-6 px-lg-5 px-4 pt-6">
            <div className="text-center">
                <h2 className="text-primary">{heading}</h2>
                <p>{subheading}</p>
            </div>
        </div>
    );
}
